import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useSiteStore } from './utils/store/useSiteStore';
import Landing from './pages/Landing';
import ViewMenu from './pages/ViewMenu';
import ViewStory from './pages/ViewStory';
import ViewRewards from './pages/ViewRewards';
import RedeemRewards from './pages/RedeemRewards';
import PrivateEvents from './pages/PrivateEvents';
import FAQ from './pages/FAQ';
import Shows from './pages/Shows';
import TourMap from './pages/TourMap';
import MerchStore from './pages/MerchStore';
import { checkHealth } from './utils/api/healthApi';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  const { sections } = useSiteStore();

  useEffect(() => {
    checkHealth()
      .then((data) => console.log('API health:', data))
      .catch((err) => console.error('API unreachable:', err));
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {sections.hero && <Route path="/" element={<Landing />} />}
        {sections.menu && <Route path="/menu" element={<ViewMenu />} />}
        {sections.origin && <Route path="/story" element={<ViewStory />} />}
        <Route path="/rewards" element={<ViewRewards />} />
        <Route path="/redeem" element={<RedeemRewards />} />
        <Route path="/booking" element={<PrivateEvents />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/shows" element={<Shows />} />
        <Route path="/map" element={<TourMap/>}/>
        <Route path="/store" element={<MerchStore/>}/>
      </Routes>
    </BrowserRouter>
  );
}